import React from "react";
import { StatusValue } from "../../../../application/domain/proc-management";
import { PublishStatus } from "../../../../application/domain/procedures/procedure-entity";

type severity = "info" | "warning";

type notificationContent = {
  iconClass: string;
  severity: severity;
  headerMsg: string;
};

export const ProcedureOnlineInfoSmartApplyNotification: React.FC<{
  linkForSmartApplyProcDetail: string;
  procStatus: StatusValue;
  smartApplyStatus: PublishStatus;
}> = ({ linkForSmartApplyProcDetail, procStatus, smartApplyStatus }) => {
  const isStatusMismatch =
    procStatus === "PUBLISHED" &&
    (smartApplyStatus === "DRAFT" ||
      smartApplyStatus === "BEFORE_PUBLISH" ||
      smartApplyStatus === "UNPUBLISHED");
  const content: notificationContent = isStatusMismatch
    ? {
        iconClass: "fas fa-exclamation-triangle",
        severity: "warning",
        headerMsg:
          "アクセスできないスマート申請のリンクが手続きマスタ上で公開されます",
      }
    : {
        iconClass: "fas fa-info-circle",
        severity: "info",
        headerMsg:
          "手続きマスタで更新した内容はスマート申請には自動で反映されません",
      };
  return (
    <div className={`notification is-${content.severity} is-light mt-4`}>
      <div>
        <span className={`icon has-text-${content.severity}`}>
          <i className={content.iconClass} />
        </span>
        <strong>{content.headerMsg}</strong>
      </div>
      <div className="is-size-7 ml-5 mt-1">
        スマート申請の内容を更新する場合は
        <a
          href={linkForSmartApplyProcDetail}
          target="_blank"
          rel="noopener noreferrer"
        >
          こちら
        </a>
        から行ってください
      </div>
    </div>
  );
};
